import { render, staticRenderFns } from "./v-cost-subject-communication-fee-select.vue?vue&type=template&id=23725bc9&scoped=true&"
import script from "./v-cost-subject-communication-fee-select.vue?vue&type=script&lang=js&"
export * from "./v-cost-subject-communication-fee-select.vue?vue&type=script&lang=js&"
import style0 from "./v-cost-subject-communication-fee-select.vue?vue&type=style&index=0&id=23725bc9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23725bc9",
  null
  
)

export default component.exports